export const apiConstants = {
  url: "/api/rulegroup"
};
